export default `/* Ids List Box Component */
:host {
  color: var(--ids-dropdown-color-text-default);
  cursor: var(--ids-cursor-pointer);
  display: block;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: 16px;
  line-height: var(--ids-list-box-option-height, 32px);
  outline: none;
  min-height: var(--ids-list-box-option-height, 32px);
  padding: 0;
  text-indent: 8px;
  user-select: none;
  min-width: calc(var(--ids-input-width-10) - 2px);
  text-overflow: ellipsis;
  overflow: clip;
  width: 100%;
  white-space: nowrap;
}

:host(.multiselect-option),
:host(.icon-option) {
  display: flex;
  --ids-checkbox-label-padding-inline-end: var(--ids-space-xs);
}
:host(.multiselect-option) ::slotted(ids-icon),
:host(.icon-option) ::slotted(ids-icon) {
  margin: 0;
  margin-inline-start: var(--ids-dropdown-space-text);
}

:host(.multiselect-loaded) {
  align-items: center;
}
:host(.multiselect-loaded) ::slotted(ids-text) {
  position: relative;
  top: -1px;
}

:host([disabled]:not([disabled=false])) {
  cursor: var(--ids-cursor-default);
  opacity: 0.5;
  pointer-events: none;
}

:host(.is-selected:not(.multiselect-option)) {
  background-color: var(--ids-dropdown-color-background-selected);
  color: var(--ids-dropdown-color-text-selected);
  position: relative;
  z-index: 1;
}

:host(:hover:not(.is-selected):not([group-label]):not([no-results]):not(.multiselect-option)),
:host(.is-focused),
:host(.multiselect-option:focus),
:host(.multiselect-option.is-selected),
:host(.multiselect-option:hover) {
  background-color: var(--ids-dropdown-color-background-hover);
  position: relative;
  z-index: 0;
}

::slotted(ids-icon) {
  vertical-align: middle;
  margin: 0 var(--ids-dropdown-space-text) 2px 0;
}

::slotted(ids-avatar) {
  text-indent: 0;
  margin-inline-end: 8px;
}

::slotted(ids-icon[dir=rtl]) {
  margin: 0 0 2px var(--ids-dropdown-space-text);
}

::slotted(ids-color) {
  vertical-align: middle;
  margin-inline-end: var(--ids-dropdown-space-text);
  position: relative;
  top: -1.5px;
}

::slotted(ids-checkbox), ::slotted(ids-checkbox.multiselect-loaded) {
  flex: 0 1 auto;
  margin-inline-end: 5px;
  min-width: 0;
  padding-inline-start: 5px;
  top: 2px;
  line-height: 19px;
  position: relative;
}

::slotted(ids-checkbox) {
  top: 1px;
}

::slotted(ids-checkbox.multiselect-loaded) {
  top: -1px;
}

::slotted(.highlight) {
  display: contents;
  font-weight: var(--ids-font-weight-bold);
}

::slotted([slot=info]) {
  font-size: 12px;
  display: block;
  line-height: normal;
  padding-bottom: 8px;
  margin-top: -3px;
}

:host(.multi-column-option) {
  display: table-row;
}
:host(.multi-column-option) ::slotted(span.multi-key) {
  display: table-cell;
}

:host(.multi-column) {
  display: table-row;
  box-sizing: border-box;
}
:host(.multi-column) ::slotted(span.multi-key) {
  display: table-cell;
  box-sizing: border-box;
  padding-inline: 8px;
}

:host([group-label]) {
  cursor: var(--ids-cursor-default);
  color: var(--ids-dropdown-group-color-text);
  font-weight: var(--ids-font-weight-semibold);
}

:host([group-label]:not(:first-child)),
:host(.multiselect-border) {
  border-top: 1px solid var(--ids-dropdown-group-color-border);
  margin-top: var(--ids-dropdown-group-padding);
}

:host(.module-nav) {
  color: var(--ids-module-nav-settings-menu-item-text-color);
  min-height: var(--ids-module-nav-item-height);
  line-height: var(--ids-module-nav-item-height);
  padding-block: var(--ids-module-nav-switcher-dropdown-item-margin-block);
  position: relative;
  border-left: 4px solid transparent;
  transition: background-color 0.2s ease, border-left-color 0.2s ease;
  margin-bottom: 2px;
  border-radius: 0;
}

:host(.module-nav) ::slotted(ids-icon) {
  margin-inline-end: 8px;
  margin-block-end: 1px;
}

:host(.module-nav:hover) {
  background-color: var(--ids-module-nav-item-hover-bg-color);
  color: var(--ids-module-nav-item-hover-text-color);
}

:host(.module-nav.is-selected) {
  background-color: var(--ids-module-nav-item-hover-bg-color);
  color: var(--ids-module-nav-item-hover-text-color);
  z-index: 2;
}

:host(.show-checkboxes) {
  --ids-list-box-color-background-selected: transparent;
  --ids-list-box-color-text-selected: var(--ids-dropdown-color-text-default);
  display: flex;
  align-items: center;
  gap: 2px;
  padding-inline-start: 8px;
  background-color: transparent;
}
:host(.show-checkboxes) ::slotted(ids-checkbox) {
  flex: 0 0 18px;
  width: 18px;
  min-width: 18px;
  max-width: 18px;
  margin-bottom: 0;
  padding-inline-start: 0;
  line-height: 16px;
  position: relative;
  display: flex;
  align-items: center;
  pointer-events: none;
}
:host(.show-checkboxes) ::slotted(ids-checkbox[label]) {
  --ids-checkbox-label-top: 4px;
  --ids-checkbox-label-inset-inline-start: -3px;
  --ids-checkbox-margin-bottom: 3px;
  width: 18px;
}

:host(.show-checkboxes.multi-column-option) {
  display: table-row;
  align-items: unset;
}
:host(.show-checkboxes.multi-column-option) ::slotted(ids-checkbox) {
  display: table-cell;
  line-height: 24px;
  max-width: 25px;
  flex: unset;
  padding-inline-start: 8px;
}
:host(.show-checkboxes.multi-column-option) ::slotted(span.multi-key) {
  display: table-cell;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
